document.addEventListener('DOMContentLoaded', function () {
  // Slider

  const sliderEl = document.querySelector('.product__add-ons--carousel');

  const flktyPrevButton = document.querySelector('.product__add-ons--carousel-prev');
  const flktyNextButton = document.querySelector('.product__add-ons--carousel-next');
  const flktyOptions = {
    wrapAround: false,
    pageDots: false,
    contain: true,
    prevNextButtons: false,
    cellAlign: 'center',
    groupCells: window.innerWidth <= 485 ? 2 : 3
  };
  const flkty = new Flickity('.product__add-ons--carousel', flktyOptions);

  // Bind custom buttons
  flktyPrevButton.addEventListener('click', () => {
    flkty.previous();
  });

  flktyNextButton.addEventListener('click', () => {
    flkty.next();
  });

  // Tab click filter (just for this slider)
    // document.querySelectorAll('.product__add-ons--tab').forEach(tab => {
    //   tab.addEventListener('click', function () {
    //     const selectedHandle = this.dataset.handle;

    //     // Optional: Set active class on tabs
    //     document.querySelectorAll('.product__add-ons--tab').forEach(t => t.classList.remove('active'));
    //     this.classList.add('active');

    //     // Filter slides inside this specific swiper only
    //     sliderEl.querySelectorAll('.product__add-ons--carousel-slide').forEach(slide => {
    //       const slideHandle = slide.dataset.handle;

    //       if (selectedHandle === 'all' || slideHandle === selectedHandle) {
    //         slide.style.display = '';
    //       } else {
    //         slide.style.display = 'none';
    //       }
    //     });

    //     flkty.reloadCells();
    //     flkty.resize();
    //     flkty.select(0);
    //   });
    // });

  const allCells = Array.from(document.querySelectorAll('.product__add-ons--carousel-slide'));
  const carousel = document.querySelector('.product__add-ons--carousel');

  document.querySelectorAll('.product__add-ons--tab').forEach(button => {
    button.addEventListener('click', () => {
      const filter = button.dataset.category;

      // 1. Update active tab
      document.querySelectorAll('.product__add-ons--tab').forEach(btn =>
        btn.classList.remove('active')
      );
      button.classList.add('active');

      // Clear all slides
      flkty.remove(allCells);
      
      // Filter visible slides
      const filteredCells = filter === 'all'
        ? allCells
        : allCells.filter(cell => cell.dataset.category === filter);

      // Re-append filtered slides
      filteredCells.forEach(cell => flkty.append(cell));

      // Update Flickity layout
      flkty.reloadCells();
      flkty.select(0);
    });
  });

  document.querySelectorAll('.product__add-ons--tab-item').forEach(productAddon => {
    const addonCheckbox = productAddon.querySelector('.addon-checkbox');
    addonCheckbox.addEventListener('click', () => {
      productAddon.classList.toggle('selected');
    });
  })
  
  // Quantity
    document.querySelectorAll('.product__add-ons-qty').forEach(container => {
      const input = container.querySelector('.js-product__add-ons-qty');
      const increaseBtn = container.querySelector('.js-product__add-ons-increase'); // fixed
      const decreaseBtn = container.querySelector('.js-product__add-ons-decrease'); // fixed

      // Parse helper
      const getValue = () => parseInt(input.value) || 0;
      const getMin = () => parseInt(input.dataset.min) || 0;
      const getStep = () => parseInt(input.step) || 1;

      // Increase
      if (increaseBtn) {
        increaseBtn.addEventListener('click', function (e) {
          e.preventDefault();
          let current = getValue();
          let step = getStep();
          input.value = current + step;
          input.dispatchEvent(new Event('change'));
        });
      }
      // Decrease
      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', function (e) {
          e.preventDefault();
          let current = getValue();
          let min = getMin();
          let step = getStep();
          input.value = Math.max(current - step, min);
          input.dispatchEvent(new Event('change'));
        });
      }
      
    });


  // Add to cart
    document.querySelectorAll('.js-product__add-ons-add-cart').forEach(button => {
      button.addEventListener('click', function () {
        const container = this.closest(".product__add-ons--tab-overlay");
        const loader = this;
        const variantId = container.dataset.variantId;
        const quantityInput = container.querySelector('.js-product__add-ons-qty');
        const quantity = parseInt(quantityInput.value) || 0;

        if (!variantId) {
          alert('Missing variant ID');
          return;
        }

        if (quantity <= 0) {
          alert('Add quantity');
          return;
        }

        loader.classList.add('loading');

        // Add to Cart Extension
        const productFormElement = document.querySelector('product-form');
        
        // Cart Drawer Extension
        const cartDrawerlement = document.querySelector('cart-drawer');

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);
        formData.append('sections', productFormElement.getSectionsToRender().map((section) => section.section));
        formData.append('sections_url', window.location.pathname);
        
        fetch(`${theme.routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          },
          body: formData
          // body: JSON.stringify({
          //   id: variantId,
          //   quantity: quantity,
          // })
        })
        .then(res => res.json())
        .then(response => {
          console.log('Added to cart:', response);
          loader.classList.remove('loading');
          if (productFormElement && typeof productFormElement.renderContents === 'function') {
            productFormElement.renderContents(response);
          }
          if (cartDrawerlement && typeof cartDrawerlement.removeProductEvent === 'function') {
            cartDrawerlement.removeProductEvent();
          }
          // renderContents(response)
          
        })
        .catch(err => {
          console.error('Add to cart error:', err);
          alert('Failed to add to cart');
        });
      });
    });
});

